const DEFAULT_REGULAR_ONLY = false;

export default DEFAULT_REGULAR_ONLY;
